import React from 'react';
import PropTypes from 'prop-types';
import { ICON_TYPES } from '../../../../../../../../../components/SelectIcon/constants';

const CategoryIcon = ({ icon }) => {
  if (icon?.icon_type) {
    switch (icon.icon_type) {
    case ICON_TYPES.IMAGE:
      return (
        <div className="service-table__category-image" style={{ backgroundImage: `url(${icon.url})` }} />
      )
    case ICON_TYPES.ICON:
      return (
        <span className={`service-table__category-icon ${icon.icon}`} />
      )
    case ICON_TYPES.EMOJI:
      return <span className="service-table__category-icon">{icon.icon}</span>
    default:
      return null;
    }
  }
  return null;
}

CategoryIcon.propTypes = {
  icon: PropTypes.object,
}

export default CategoryIcon;
